import { render } from "./CategoryDynamicChart.vue?vue&type=template&id=29b06d22&scoped=true"
import script from "./CategoryDynamicChart.vue?vue&type=script&lang=js"
export * from "./CategoryDynamicChart.vue?vue&type=script&lang=js"

import "./CategoryDynamicChart.vue?vue&type=style&index=0&id=29b06d22&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b06d22"]])

export default __exports__